exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reporting-css-section .reporting-branch-dd .multiSelect .show {\n  display: block !important; }\n\n.reporting-css-section .reporting-branch-dd .multiSelect .checkboxLayer {\n  display: inline-block;\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  width: 200px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/reporting/components/liability/liability.scss
// module id = 1068
// module chunks = 1